// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"86b67bc2","667":"fef4cf05","977":"5d4208e8"}[chunkId] + ".chunk.js";
};